require('./bootstrap');
require('./legacy');

window.data = window.data || {};

window.addEventListener('feedback.sentiment_sent', e => {
    dataLayer.push({
        'event': 'helpcentre.feedback.sentiment_selected',
        'helpcentre.feedback.sentiment': e.detail.sentiment
    })
})

window.addEventListener('search.suggestion_selected', e => {
    dataLayer.push({
        'event': 'helpcentre.search.suggestion_selected',
        'helpcentre.search.suggestion': e.detail.uri
    })
})

if (data.is_aliasing || data.environment == 'test') {
    var acctSubDomain = 'msds-acct';
    var liveAliasSubDomain = 'csintra1';
    var newSubDomain = data.environment == 'test' ? acctSubDomain : liveAliasSubDomain;
    var anchortags = document.querySelectorAll("a[href*='msds.open.ac.uk']");

    anchortags.forEach(function (tag) {
        tag.href = tag.href.replace('msds', newSubDomain);
    });
}
